import { get } from "@readai/common/api";
import type { BotStatus } from "@readai/common/types/botTypes";

interface GetBotStatusOpts {
  hostname?: string;
}

export const getStatus = async (
  sessionId: string,
  opts: GetBotStatusOpts = {},
): Promise<BotStatus[]> => {
  const hostname = opts?.hostname ?? "";
  const response: BotStatus[] = await get(
    `${hostname}/bots?session_id=${sessionId}`,
    { withCreds: true },
  );
  return response;
};
